<script>
import ReportsModalBase from "@/components/base_components/ReportsModalBase";

export default {
  name: "ForeignVATModal",
  extends: ReportsModalBase,
  methods: {
    onSubmitBeforeEmit(report_initial_values){
      this.$store.commit('taxreports/setForeignVATReportInitialValues', report_initial_values)
    }
  }
};
</script>